import type {TemplateNode} from '@/uptk/core/components/moduleEntity/template/templateTypes';
import type {DesignModuleSpecJson} from '../data/contracts';
import type {CompiledTemplate} from './compileNativeTemplate';
import {pageTemplate} from './templateRebase';

const identity=(key:string)=>key.replace(/\.tpl\.[^.]+\./,'.tpl.*.');
/** A reviewed translation or hidden prototype text is a Maker decision, not a new question on each compile. */
export function preserveTextDecisions(spec:DesignModuleSpecJson,page:string,result:CompiledTemplate):void{
 const previous=pageTemplate(spec,page);if(!previous)return;
 const hidden=new Set<string>();
 const walk=(node:TemplateNode)=>{
  if(node.type==='text'&&node.hiddenPrototype?.message)hidden.add(identity(node.hiddenPrototype.message));
  if(node.type==='el')node.children.forEach(walk);
  if(node.type==='repeat'){walk(node.item);walk(node.empty);}
 };walk(previous);
 const messages=(spec.presentation as {templateMessages?:Record<string,Record<string,string>>}|undefined)?.templateMessages??{};
 const prior=new Map(Object.entries(messages).map(([key,texts])=>[identity(key),texts]));
 const reviewed=new Set<string>();
 for(const [key,texts] of Object.entries(result.messages)){
  const old=prior.get(identity(key));
  if(old&&Object.entries(old).some(([locale,value])=>!!value&&value!==texts[locale])){result.messages[key]={...texts,...old};reviewed.add(identity(key));}
 }
 result.textReviews=result.textReviews?.filter(item=>!hidden.has(identity(item.key))&&!reviewed.has(identity(item.key)));
}
